<div class="invite-users-dialog">

  <h2 mat-dialog-title>{{ title }}</h2>

  <mat-dialog-content>
    <form [formGroup]="inviteUserForm" autocomplete="off" data-cy="invite-user-form">
      @if (mode === 1) {
        <mat-form-field>
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="emailAddress">
          @if (inviteUserForm.controls['emailAddress']?.errors?.email) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
          @if (inviteUserForm.controls['emailAddress']?.errors?.required) {
            <mat-error>
              Email address is required
            </mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Role(s)</mat-label>
        <mat-select id='roleIds' formControlName="roleIds" data-cy="user-invitation-role-ids" multiple>
          <mat-option disabled>--- Choose role(s) ---</mat-option>
          @for (role of allRoles; track role) {
            <mat-option [value]="role.id">
              {{ role.name }}
            </mat-option>
          }
        </mat-select>
        @if (inviteUserForm.controls['roleIds']?.errors?.emptyArray) {
          <mat-error>
            Please select a role from the list
          </mat-error>
        }
      </mat-form-field>

      @if (mode === 1 && autoSelectTenant == null) {
        <mat-form-field>
          <mat-label>Tenant</mat-label>
          <mat-select id='tenantId' formControlName="tenantId" data-cy="user-invitation-tenant-id">
            <mat-option>--- Choose a tenant ---</mat-option>
            @for (tenant of tenants; track tenant) {
              <mat-option [value]="tenant.id">
                {{ tenant.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button (click)="close()">Close</button>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  </mat-dialog-actions>

</div>
